module.exports = __webpack_public_path__ + "s/img/Glam_D_3.b4d0cf1a.jpg";